
import folderImg from "../Editor/folder.png";
import linkPictureImg from "../picture/LinkWWW.png";
import dataBaseWWWImg from "../picture/DataBaseWWW.png";
import wwwCharImg from "../picture/WWWCHAR.png";
import arrowLeftImg from "../picture/arrowLeft.png";
import noteDocumentImg from "../picture/NoteDocument.png";
import text44Img from "../picture/text4.4.png";
import Button from "../AdminPanel/Custom/Button/Button.jsx";

const SettingsEditorSegment7 = ({ data, handleCheckboxChange, handleSetValue }) => {

  if (!data) return null

  return (
    <div style={{display: "flex", gap: "30px"}}>
      <div className="se-segment7">
        <div className="se-segment7-buttons">
          <Button style={{width: "20%", backgroundColor: "white"}}>
            <img src={linkPictureImg}/>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.internal_link === false ? 0.5 : 1}}>
            <img src={dataBaseWWWImg}/>
            <div className="se-segment6-buttons-circle" style={{color: "green"}}>28</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.external_link === false ? 0.5 : 1}}>
            <img src={wwwCharImg}/>
            <div className="se-segment6-buttons-circle">29</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.report_link === false ? 0.5 : 1}}>
            <img src={noteDocumentImg}/>
            <div className="se-segment6-buttons-circle">30</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.document_link === false ? 0.5 : 1}}>
            <img src={folderImg}/>
            <div className="se-segment6-buttons-circle">31</div>
          </Button>
        </div>

        <div className="se-segment7-row1">
          <div style={{width: "20%"}}></div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="internal_link"
              checked={data.internal_link}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox" style={{color: "green"}}>28</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="external_link"
              checked={data.external_link}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">29</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="report_link"
              checked={data.report_link}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">30</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="document_link"
              checked={data.document_link}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">31</div>
          </div>
        </div>

        <div className="se-segment7-row2">
          <div className="one-checbox">
            <div className="num-checkbox" style={{color: "green"}}>28</div>
            <div className="num-checkbox">29</div>
            <img src={arrowLeftImg} style={{width: "10px", height: "10px"}}/>
            <div className="num-checkbox">8</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="hyperlink_to_pdf"
              checked={data["hyperlink_to_pdf"] == "1"}
              onChange={() => handleSetValue("1", "hyperlink_to_pdf")}
            />
            <div style={{fontSize: "14px", fontWeight: "bold", color: "blue", textDecoration: "underline"}}>http://...</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="hyperlink_to_pdf"
              checked={data["hyperlink_to_pdf"] == "2"}
              onChange={() => handleSetValue("2", "hyperlink_to_pdf")}
            />
            <div style={{fontSize: "14px", fontWeight: "bold"}}>http://...</div>
          </div>
        </div>
      </div>
      <div>
        <img src={text44Img} style={{width: "100%", height: "140px"}}/>
      </div>
    </div>
  );
};

export default SettingsEditorSegment7;